import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { IItem } from '@coreui/angular-pro'
import { RestService } from 'src/app/services/rest/rest.service';
import { UserProfileReport } from 'src/app/interfaces/apiresponses'; 
import { DatePipe } from '@angular/common';
import { TableUtil } from 'src/app/shared/utils/table.util';

@Component({
  selector: 'app-support-user-profile-audit-report',
  templateUrl: './support-user-profile-audit-report.component.html',
  styleUrls: ['./support-user-profile-audit-report.component.scss'],
  providers: [DatePipe]
})

export class SupportUserProfileAuditReportComponent {
  nItems: number = 10

  constructor(private restApi: RestService, private datePipe: DatePipe, private changeDetector: ChangeDetectorRef){

  }

  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any

  closeAlert(event: any){

  }

  alertVisibility(event: any)
  {
    this.bAlert = event.state
  }

  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {}) {
    this.alertHeaderText = heading;
    this.alertBodyText = body;
    this.bShowSecondAlertButton = showSecondButton;
    this.alertSecondButtonText = secondButtonText;
    this.alertCloseButtonText = closeButtonText;
    this.alertBoxData = data;
    this.bAlert = true;
  
    // Disable scrolling
    document.body.style.overflow = 'hidden';
  }
  

  onAlertButtonClick(event: any){
    this.bAlert = event.state
    if (event.data.action === 1){
    }
  }

  date = new Date();
  startDate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  endDate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);

  columns = [
    {
      key: 'cif',
      label: 'CIF',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'companyName',
      label: 'Company',
      _cellProps: {align: 'middle'},
      filter: true
    },
    {
      key: 'makerEmail',
      label: 'Maker',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'checkerEmail',
      label: 'Checker',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'requestedOn',
      label: 'Requested On',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'decisionOn',
      label: 'Decision On',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'transactionType',
      label: 'Request Type',
      _cellProps: {align: 'middle'},
      filter: false
    },
    {
      key: 'oldName',
      label: 'Previous Name',
      filter: false
    },
      
    {
      key: 'oldEmailId',
      label: 'Previous Email',
      filter: false
    },
    {
      key: 'oldMobileNumber',
      label: 'Previous Mobile',
      filter: false
    },
    {
      key: 'oldGender',
      label: 'Previous Gender',
      filter: false
    },
    {
      key: 'oldDateOfBirth',
      label: 'Previous DOB',
      filter: false
    },

    {
      key: 'oldIdType',
      label: 'Previous ID Type',
      filter: false
    },
 
    {
      key: 'oldEidNumber',
      label: 'Previous ID Number',
      filter: false
    }, 
    {
      key: 'oldNationalityCountryCode',
      label: 'Previous Nationality',
      filter: false
    }, 
    {
      key: 'oldExpiresOn',
      label: 'Previous ID Expires On',
      filter: false
    }, 
    {
      key: 'name',
      label: 'Name',
      filter: false
    },
      
    {
      key: 'emailId',
      label: 'Email',
      filter: false
    },
    {
      key: 'mobileNumber',
      label: 'Mobile',
      filter: false
    },
 
    {
      key: 'gender',
      label: 'Gender',
      filter: false
    },
    {
      key: 'dateOfBirth',
      label: 'Date of Birth',
      filter: false
    }, 
    {
      key: 'newIdType',
      label: 'New ID Type',
      filter: false
    }, 
    {
      key: 'eidNumber',
      label: 'ID Number',
      filter: false
    },
    {
      key: 'nationalityCountryCode',
      label: 'Nationality',
      filter: false
    },
    {
      key: 'expiresOn',
      label: 'ID Expires On',
      filter: false
    }, 
    
  ];

  reportData: IItem[] = []
  bShowDownloadButton: boolean = false
  selectedItems = [2, 3];

  getDateString(dateValue: Date){
    return this.datePipe.transform(dateValue,"yyyy-MM-dd")
  }

  getDateDisplayString(dateValue: Date){
    var displayDate = this.datePipe.transform(dateValue,"dd-MM-yyyy")

    if (displayDate === '01-01-0001')
      return ''
    else
      return displayDate
  }

  // Search Form
  searchReportType: string = ''

  cifSearchForm = new FormGroup({
    searchReportTypeControl: new FormControl(this.searchReportType),
  })

  get searchReportTypeControl() {return this.cifSearchForm.get('searchReportTypeControl')}

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  onStartDateChane(item: any){
    this.bShowDownloadButton = false
    this.startDate = item
    this.reportData = []
  }

  onEndDateChane(item: any){
    this.bShowDownloadButton = false
    this.endDate = item
    this.reportData = []
  }

  generateReport(){
    let startDateString = this.getDateString(this.startDate)
    let endDataString = this.getDateString(this.endDate)

    if (this.searchReportTypeControl?.value != null && startDateString != null && endDataString != null){

      this.restApi.getUserManagementReport(startDateString, endDataString).subscribe({
        next: (v: UserProfileReport) => {
          this.bShowDownloadButton = true
          
          this.reportData = v.userActivities.map((item, Reference) => {
            const _selected = this.selectedItems.includes(Reference);
            return {
              ...item,
              _selected
            };
          })
        },
        error: (e) => {

        }
      })
    }
  }

  
  downloadReport() {
    const columns = [
      { key: 'cif', label: 'CIF' },
      { key: 'companyName', label: 'Company' },
      { key: 'makerEmail', label: 'Maker' },
      { key: 'checkerEmail', label: 'Checker' },
      { key: 'requestedOn', label: 'Requested On' },
      { key: 'decisionOn', label: 'Decision On' },
      { key: 'transactionType', label: 'Request Type' },
      { key: 'oldName', label: 'Previous Name' },
      { key: 'oldEmailId', label: 'Previous Email' },
      { key: 'oldMobileNumber', label: 'Previous Mobile' },
      { key: 'oldGender', label: 'Previous Gender' },
      { key: 'oldDateOfBirth', label: 'Previous DOB' },
      { key: 'oldIdType', label: 'Previous ID Type' },
      { key: 'oldEidNumber', label: 'Previous ID Number' },
      { key: 'oldNationalityCountryCode', label: 'Previous Nationality' },
      { key: 'oldExpiresOn', label: 'Previous ID Expires On' },
      { key: 'name', label: 'Name' },
      { key: 'emailId', label: 'Email' },
      { key: 'mobileNumber', label: 'Mobile' },
      { key: 'gender', label: 'Gender' },
      { key: 'dateOfBirth', label: 'Date of Birth' },
      { key: 'newIdType', label: 'New ID Type' },
      { key: 'eidNumber', label: 'ID Number' },
      { key: 'nationalityCountryCode', label: 'Nationality' },
      { key: 'expiresOn', label: 'ID Expires On' }
    ];

    const formattedData = this.reportData.map(item => {
      const newItem: any = {};

      columns.forEach(col => {
        let value = item[col.key];

        // Apply date formatting for date fields
        switch (col.key) {
          case 'requestedOn':
          case 'decisionOn':
          case 'oldDateOfBirth':
          case 'oldExpiresOn':
          case 'dateOfBirth':
          case 'expiresOn':
            newItem[col.label] = this.getDateDisplayString(value);
            break;
          default:
            newItem[col.label] = value;
        }
      });

      return newItem;
    });

    if (TableUtil.exportArrayToExcel(formattedData, 'UserProfileAuditReport')) {
      this.showAlertBox('Downloaded', 'The report is downloaded. Please look for the report in your browser download section.');
    } else {
      this.showAlertBox('Sorry', 'Unable to download the report. Please contact technical support.');
    }
  }



}
